module.exports = {
  BLOG_FEED_PATH: '/blog-feed.xml'
};